export const trackUpsellStage = (
  stage,
  customerId,
  upsellCorrelationId,
  csrfToken,
  offerId,
  family,
  newProvider = false,
  errorInfo = null
) => {
  const params = new URLSearchParams({ stage, correlation: upsellCorrelationId });
  return fetch(`/track-payment-stage?${params}`, {
    method: 'POST',
    headers: new Headers({
      'x-customerId': customerId,
      'CSRF-Token': csrfToken,
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(errorInfo || { offerId, family, newProvider }),
  });
};
